<template>
    <div>
        <div class="crousel-container mt-1">
            <carousel ref="my-carousel" :navigationEnabled="isDesktop"
                :paginationEnabled="true" navigationNextLabel=" " navigationPrevLabel=" "
                :autoplay="false" :loop="true" :speed="500" :class="isDesktop ? 'bannerview' : 'mobileBannerView'" :perPage="1"
                :paginationPadding="isDesktop ? 6 : 2" :paginationSize="6" :paginationPosition="'bottom'"
                >
                  <slide class="" v-for="(bannerImage, index2) in banners.mobile" :key="index2">
                    <a
                        :href="bannerImage.image_redirect_link"
                        class="d-inline-block w-100"
                    >
                        <img style="width: 100%;" :src="bannerImage.image" class="img-auto" width="1500" height="385"/>
                    </a>
                  </slide>
            </carousel>
            <div class="corusel-description">
                <span>{{ allData.main_content_2_disclaimer }}</span>
            </div>
            <div class="corusel-btn mt-3">
              <a :href="allData && allData.page_header_button_redirect_link">
                <span>{{ allData.page_header_button_text || 'EXPLORE' }}</span>
              </a>
            </div>
        </div>
        <div class="gallry-1 mt-3">
            <div class="fullwidth-img row">
                <div class="col-md-12" v-for="(img, index) in gallaryImages[isDesktop? 'desktop' :'mobile'].fullWidthImg" :key="index">
                    <a
                        :href="img.imgNavigateLink || '#'"
                        class="d-inline-block w-100"
                        @click="preventEmptyLink(img.imgNavigateLink)"
                    >
                        <img style="width: 100%;" :src="`${img.imgLink}?t=${new Date().getTime()}`" class="img-auto" width="1500" height="385"/>
                    </a>
                </div>
            </div>
            <div class="halfWidth-img" :class="isDesktop ? 'mt-4 mx-3' : 'mt-3 mx-3'">
                <div class="row">
                    <div class="col-6" v-for="(img, index) in gallaryImages[isDesktop? 'desktop' :'mobile'].halfWidthImg" :key="index">
                        <a
                            :href="img.imgNavigateLink || '#'"
                            @click="preventEmptyLink(img.imgNavigateLink)"
                        >
                            <img :src="`${img.imgLink}?t=${new Date().getTime()}`" class="img-half-width"/>
                        </a>
                        <div class="img-description">
                            <p>{{ img.imgDescription }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="media-conatiner mt-3" :class="isDesktop ? 'mt-5' : 'mt-3'">
            <div  class='w-full vedio-player' v-if="!isDesktop">
              <VideoPlayer
                :src="mediaGallry[isDesktop? 'desktop' : 'mobile'].video.videoLink"
                :poster="mediaGallry[isDesktop? 'desktop' : 'mobile'].video.poster"
                :type="'care_page'"
                :playVideo="true"
              />
            </div>
            <div class="halfWidth-img" :class="isDesktop ? 'mt-3 mx-2' : 'mt-2 mx-2'">
                <div class="row">
                    <div :class="'col-' + img.col" class='bx' v-for="(img, index) in mediaGallry[isDesktop? 'desktop' : 'mobile'].halfWidthImg" :key="index">
                        <a
                            v-if="img.imgLink"
                            :href="img.imgNavigateLink || '#'"
                            @click="preventEmptyLink(img.imgNavigateLink)"
                        >
                            <img :src="`${img.imgLink}?t=${new Date().getTime()}`" class="img-half-width" :class="'img-col-' + img.col"/>
                        </a>
                        <div class="padding0" :class="'img-description-' + img.col">
                            <span>{{ img.imgDescription }}</span>
                        </div>
                        <div v-if="img.imgDescription" class="corusel-btn mt-3">
                          <a :href="'https://www.thesouledstore.com/artists/nomad'">
                            <span>{{ 'EXPLORE' }}</span>
                          </a>
                      </div>
                    </div>
                </div>
              </div>
              <div class="product-crousel-container" :class="isDesktop ? 'mt-3' : 'mt-2 mx-1'">
               <div class="product">
                 <carousel
                   :navigationEnabled="isDesktop"
                   :paginationEnabled="false"
                   navigationNextLabel=" " navigationPrevLabel=" "
                   :autoplay="false"
                   class="bannerview"
                   :perPageCustom="[[480, 2], [768, 4], [1200, 4], [1920, 4]]"
                   :perPage="isDesktop ? 4 : 2.5"
                 >
                 <slide v-for="(product, productIndex) in products" :key="productIndex" class="col">
                   <a :href="product.productLink">
                     <img style="width: 100%;" :src="`${product.productImg}?t=${new Date().getTime()}`" alt="product" />
                     <p class="product-name">{{ product.productName }}</p>
                   </a>
                 </slide>
                 </carousel>

               </div>
              </div>
        </div>
        <div class="gallry-2 mt-3" :class="isDesktop ? 'px-2' : ''">
            <div class="halfWidth-img">
                <div class="row">
                    <div class="col-6" v-for="(img, index) in secondGallaryImages[isDesktop? 'desktop' :'mobile'].halfWidthImg" :key="index">
                        <a
                            :href="img.imgNavigateLink || '#'"
                            @click="preventEmptyLink(img.imgNavigateLink)"
                        >
                            <img :src="`${img.imgLink}?t=${new Date().getTime()}`" class="img-half-width second-gal-hw-img"/>
                        </a>
                    </div>
                </div>
            </div>
            <div class="fullwidth-img row">
                <div class="col-md-12 np" v-for="(img, index) in secondGallaryImages[isDesktop? 'desktop' :'mobile'].fullWidthImg" :key="index">
                    <a
                        :href="img.imgNavigateLink || '#'"
                        class="d-inline-block w-100"
                        @click="preventEmptyLink(img.imgNavigateLink)"
                    >
                        <img style="width: 100%;" :src="`${img.imgLink}?t=${new Date().getTime()}`" class="img-auto second-gal-fw-img" width="1500" height="385"/>
                    </a>
                    <div class="corusel-description mt-3">
                      <span>{{ img.imgDescription }}</span>
                  </div>
                </div>
            </div>
        </div>
        <div class="listing mt-4">
          <div class="listing-header">
            <p>SHOP PHASE 1</p>
          </div>
          <div class="listing-container row mt-3">
            <div v-for="(product, index4) in listingProducts" :key="index4" class="product-card col-lg-3 col-md-6 col-6 mt-1">
                <a :href="product.productLink">
                  <img :src="`${product.productImg}?t=${new Date().getTime()}`" alt="product" />
                  <p class="product-name">{{ product.productName }}</p>
                </a>
            </div>
          </div>
        </div>
    </div>
</template>
<script>
import {Carousel, Slide} from 'vue-carousel'
import carouselSlider from './common/carouselSlider.vue'
import VideoPlayer from './common/VideoPlayer.vue'
export default {
  name: 'AnimalDonation',
  components: {
    Carousel,
    Slide,
    carouselSlider,
    VideoPlayer
  },
  data () {
    return {
      banners: {
        mobile: []
      },
      allData: [],
      isDesktop: this.$parent.isDesktop,
      gallaryImages: {
        mobile: {
          fullWidthImg: [
            {imgLink: 'https://prod-img.thesouledstore.com/public/theSoul/uploads/nomad1/gal1-mweb-fw-1.jpg', imgNavigateLink: ''}
          ],
          halfWidthImg: [
            {
              imgLink: 'https://prod-img.thesouledstore.com/public/theSoul/uploads/nomad1/gal1-hw-1.jpg',
              imgNavigateLink: 'https://www.thesouledstore.com/product/hooded-sweater-nomad-men',
              imgDescription: `Traditionally, cable knits were used in rugged fisherman sweaters, known for their durability and warmth, but with this Zipper Hoodie, it’s reimagined with a modern nomadic spirit.`
            },
            {
              imgLink: 'https://prod-img.thesouledstore.com/public/theSoul/uploads/nomad1/gal1-hw-2.jpg',
              imgNavigateLink: 'https://www.thesouledstore.com/product/oversized-tshirts-nomad-primal',
              imgDescription: `The front features a hand with roots, symbolizing deep connection to nature, while the back showcases a mammoth skull intertwined with cave art, narrating ancient explorers’ tales of resilience and adventure.`
            }
          ]
        },
        desktop: {
          fullWidthImg: [
            {imgLink: 'https://prod-img.thesouledstore.com/public/theSoul/uploads/nomad1/gal1-fw-1.jpg', imgNavigateLink: ''}
          ],
          halfWidthImg: [
            {
              imgLink: 'https://prod-img.thesouledstore.com/public/theSoul/uploads/nomad1/gal1-hw-1.jpg',
              imgNavigateLink: 'https://www.thesouledstore.com/product/hooded-sweater-nomad-men',
              imgDescription: `Traditionally, cable knit technique used by rugged cavemen is reimagined with a modern nomadic spirit.`
            },
            {
              imgLink: 'https://prod-img.thesouledstore.com/public/theSoul/uploads/nomad1/gal1-hw-2.jpg',
              imgNavigateLink: 'https://www.thesouledstore.com/product/oversized-tshirts-nomad-primal',
              imgDescription: `Mammoth skull intertwined with ancient tool art, narrating ancient explorers’ tales of resilience and adventure.`
            }
          ]
        }
      },
      mediaGallry: {
        mobile: {
          video: {
            videoLink: 'https://video.thesouledstore.com/nomad_launch_reel/nomad_launch_reel.m3u8',
            poster: 'https://prod-img.thesouledstore.com/public/theSoul/uploads/nomad1/poster-mweb.jpg'
          },
          halfWidthImg: [
            {
              imgLink: 'https://prod-img.thesouledstore.com/public/theSoul/uploads/nomad1/media-mweb-hw-1.jpg',
              imgNavigateLink: '',
              imgDescription: ``,
              col: 7
            },
            {
              imgLink: '',
              imgNavigateLink: '',
              imgDescription: `Inspired by the Indus Valley Civilization, a tribute to the earliest form of artistic storytelling—terracotta pot art capturing the essence of a nomadic life - rooted in craftsmanship, survival, and movement.`,
              col: 5
            }
          ]
        },
        desktop: {
          video: {
            videoLink: 'https://video.thesouledstore.com/nomad_launch_reel/nomad_launch_reel.m3u8',
            poster: 'https://prod-img.thesouledstore.com/public/theSoul/uploads/nomad1/poster.jpg'
          },
          halfWidthImg: [
            {
              imgLink: 'https://prod-img.thesouledstore.com/public/theSoul/uploads/nomad1/media-hw-1.jpg',
              imgNavigateLink: '',
              imgDescription: '',
              col: 7
            },
            {
              imgLink: '',
              imgNavigateLink: '',
              imgDescription: `Inspired by the Indus Valley Civilization, a tribute to the earliest form of artistic storytelling—terracotta pot art capturing the essence of a nomadic life - rooted in craftsmanship, survival, and movement.`,
              col: 5
            }
          ]
        }
      },
      products: [
        {
          productImg: 'https://prod-img.thesouledstore.com/public/theSoul/uploads/nomad1/cr-prd-1.jpg',
          productName: 'Compass',
          categories: 'Crop Top',
          productLink: 'https://www.thesouledstore.com/product/nomad-compass-oversized-tshirt'
        },
        {
          productImg: 'https://prod-img.thesouledstore.com/public/theSoul/uploads/nomad1/cr-prd-2.jpg',
          productName: 'Sandstorm',
          categories: 'Crop Top',
          productLink: 'https://www.thesouledstore.com/product/nomad-mystic-oversized-tshirt'
        },
        {
          productImg: 'https://prod-img.thesouledstore.com/public/theSoul/uploads/nomad1/cr-prd-3.jpg',
          productName: 'Haven',
          categories: 'Crop Top',
          productLink: 'https://www.thesouledstore.com/product/nomad-deep-blue-super-oversized-tshirts'
        },
        {
          productImg: 'https://prod-img.thesouledstore.com/public/theSoul/uploads/nomad1/cr-prd-4.jpg',
          productName: 'Indus Brown',
          categories: 'Crop Top',
          productLink: 'https://www.thesouledstore.com/product/nomad-brown-tree-women-oversized-tshirts'
        }
      ],
      secondGallaryImages: {
        mobile: {
          fullWidthImg: [
            {
              imgLink: 'https://prod-img.thesouledstore.com/public/theSoul/uploads/nomad1/gal2-fw-1.jpg',
              imgNavigateLink: 'https://www.thesouledstore.com/product/nomad-petroglyph-super-oversized-t-shirts',
              imgDescription: `Nomad speaks to the frustration of routine, offering Nomad as a symbol of breaking free from the mundane and embracing a life of freedom, individuality, and passion by rejecting the predictable and safe life in favor of personal exploration and creativity`
            }
          ],
          halfWidthImg: [
            {
              imgLink: 'https://prod-img.thesouledstore.com/public/theSoul/uploads/nomad1/gal2-hw-1.jpg',
              imgNavigateLink: 'https://www.thesouledstore.com/product/nomad-musafir-women-jacket',
              imgDescription: `Discover the NOMAD Collection: exclusive capsule`
            },
            {
              imgLink: 'https://prod-img.thesouledstore.com/public/theSoul/uploads/nomad1/gal2-hw-2.jpg',
              imgNavigateLink: 'https://www.thesouledstore.com/product/nomad-compass-oversized-tshirt',
              imgDescription: `Discover the NOMAD Collection: exclusive capsule`
            }
          ]
        },
        desktop: {
          fullWidthImg: [
            {
              imgLink: 'https://prod-img.thesouledstore.com/public/theSoul/uploads/nomad1/gal2-fw-1.jpg',
              imgNavigateLink: 'https://www.thesouledstore.com/product/nomad-petroglyph-super-oversized-t-shirts',
              imgDescription: `NOMAD breaks free from the mundane routine, embracing a life of freedom and passion - with high quality fabrics, innovative techniques and a design philosophy of personal exploration.`
            }
          ],
          halfWidthImg: [
            {
              imgLink: 'https://prod-img.thesouledstore.com/public/theSoul/uploads/nomad1/gal2-hw-1.jpg',
              imgNavigateLink: 'https://www.thesouledstore.com/product/nomad-musafir-women-jacket',
              imgDescription: `Discover the NOMAD Collection: A Journey Into Tropical Glamour`
            },
            {
              imgLink: 'https://prod-img.thesouledstore.com/public/theSoul/uploads/nomad1/gal2-hw-2.jpg',
              imgNavigateLink: 'https://www.thesouledstore.com/product/nomad-compass-oversized-tshirt',
              imgDescription: `Discover the NOMAD Collection: A Journey Into Tropical Glamour`
            }
          ]
        }
      },
      listingProducts: [
        {
          productImg: 'https://prod-img.thesouledstore.com/public/theSoul/uploads/nomad1/ls-prd-1.jpg',
          productName: 'Compass',
          productLink: 'https://www.thesouledstore.com/product/nomad-compass-oversized-tshirt'
        },
        {
          productImg: 'https://prod-img.thesouledstore.com/public/theSoul/uploads/nomad1/ls-prd-2.jpg',
          productName: 'Musafir',
          productLink: 'https://www.thesouledstore.com/product/nomad-musafir-men-bomber-jackets'
        },
        {
          productImg: 'https://prod-img.thesouledstore.com/public/theSoul/uploads/nomad1/ls-prd-3.jpg',
          productName: 'Indus Green',
          productLink: 'https://www.thesouledstore.com/product/nomad-forest-super-oversized-tshirts'
        },
        {
          productImg: 'https://prod-img.thesouledstore.com/public/theSoul/uploads/nomad1/ls-prd-4.jpg',
          productName: 'Sandstorm',
          productLink: 'https://www.thesouledstore.com/product/nomad-mystic-women-oversized-t-shirts'
        },
        {
          productImg: 'https://prod-img.thesouledstore.com/public/theSoul/uploads/nomad1/ls-prd-5.jpg',
          productName: 'Haven',
          productLink: 'https://www.thesouledstore.com/product/nomad-deep-blue-super-oversized-tshirts'
        },
        {
          productImg: 'https://prod-img.thesouledstore.com/public/theSoul/uploads/nomad1/ls-prd-6.jpg',
          productName: 'Indus Brown',
          productLink: 'https://www.thesouledstore.com/product/nomad-petroglyph-super-oversized-t-shirts'
        },
        {
          productImg: 'https://prod-img.thesouledstore.com/public/theSoul/uploads/nomad1/ls-prd-7.jpg',
          productName: 'Sandstorm',
          productLink: 'https://www.thesouledstore.com/product/nomad-mystic-oversized-tshirt'
        },
        {
          productImg: 'https://prod-img.thesouledstore.com/public/theSoul/uploads/nomad1/ls-prd-8.jpg',
          productName: 'Indus Brown',
          productLink: 'https://www.thesouledstore.com/product/nomad-brown-tree-women-oversized-tshirts'
        },
        {
          productImg: 'https://prod-img.thesouledstore.com/public/theSoul/uploads/nomad1/ls-prd-9.jpg',
          productName: 'Horizon',
          productLink: 'https://www.thesouledstore.com/product/hooded-sweater-nomad-men'
        },
        {
          productImg: 'https://prod-img.thesouledstore.com/public/theSoul/uploads/nomad1/ls-prd-10.jpg',
          productName: 'Primal',
          productLink: 'https://www.thesouledstore.com/product/oversized-tshirts-nomad-primal'
        },
        {
          productImg: 'https://prod-img.thesouledstore.com/public/theSoul/uploads/nomad1/ls-prd-11.jpg',
          productName: 'Terra',
          productLink: 'https://www.thesouledstore.com/product/desert-nomad-oversized-pullover'
        },
        {
          productImg: 'https://prod-img.thesouledstore.com/public/theSoul/uploads/nomad1/ls-prd-12.jpg',
          productName: 'Musafir',
          productLink: 'https://www.thesouledstore.com/product/nomad-musafir-women-jacket'
        },
        {
          productImg: 'https://prod-img.thesouledstore.com/public/theSoul/uploads/nomad1/ls-prd-13.jpg',
          productName: 'Pathfinder',
          productLink: 'https://www.thesouledstore.com/product/nomad-denim-dream-super-oversized-tshirt'
        },
        {
          productImg: 'https://prod-img.thesouledstore.com/public/theSoul/uploads/nomad1/ls-prd-14.jpg',
          productName: 'Terra',
          productLink: 'https://www.thesouledstore.com/product/nomad-desert-women-oversized-hoodies'
        },
        {
          productImg: 'https://prod-img.thesouledstore.com/public/theSoul/uploads/nomad1/ls-prd-15.jpg',
          productName: 'Compass',
          productLink: 'https://www.thesouledstore.com/product/nomad-compass-women-oversized-t-shirts'
        }
      ]
    }
  },
  created () {
    this.$store.dispatch('GET_DONATION_DATA_FROM_MOBILE_CMS').then((response) => {
      this.banners.mobile = this.isDesktop ? response.nomad_page_desktop.main_content_1_crousel_images : response.nomad_page_mweb.main_content_1_crousel_images
      this.allData = this.isDesktop ? response.nomad_page_desktop : response.nomad_page_mweb
    })
  },
  methods: {
    preventEmptyLink (link) {
      if (!link) {
        event.preventDefault()
      }
    }
  }
}
</script>
<style>
.corusel-description {
    margin-top: 30px !important;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
}

.img-half-width {
    width: 1500px;
    max-height: 725px;
}

.corusel-description span {
    width: 50%;
    align-self: stretch;
    color: #171717;
    text-align: center;
    font-family: "Source Sans Pro";
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 26px;
    letter-spacing: 0.5px;
}

.corusel-btn {
    display: flex;
    padding: 25px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    margin-top: 20px;
}
.corusel-btn span {
    cursor: pointer;
    border: 0.5px solid #63080A;
    color: #63080A;
    text-align: center;
    padding: 8px 20px;
    font-family: "Source Sans Pro";
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 9.223px; /* 46.115% */
    letter-spacing: 0.5px;
    text-transform: capitalize !important;
}
.pro-list {
    -webkit-box-flex: 0;
    -webkit-flex: 0 0 80%;
    -ms-flex: 0 0 80%;
    flex: 0 0 80%;
    max-width: 80%;
  }

.img-description {
  margin-top: 10px;
  width: 80%;
  margin-left: 10px;

  p {
      color: #171717;
      font-family: "Source Sans Pro";
      font-size: 20px;
      font-style: normal;
      font-weight: 400;
      line-height: 26px;
      letter-spacing: 0.5px;
    }
}

.np {
  padding: 0 !important;
}

.halfWidth-img {
    display: flex;
    align-items: center;
    justify-content: center;
}

.img-col-5 {
  /* margin-top: 70px; */
  height: 350px;
}

.img-description-5 {
  margin-top: 200px;
  span {
    display: flex;
    align-items: center;
    color: #000;
    text-align: center;
    font-family: "Source Sans Pro";
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 111.111% */
    letter-spacing: 0.5px;
    padding: 0 50px;
  }
}

.product-name {
  margin-top: 5px;
  margin-left: 10px;
  color: #060606;
  font-family: "Source Sans Pro";
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 39.871px;
  letter-spacing: 1.246px;
}

.product-categories {
  color: #414141;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  letter-spacing: 1.275px;
  margin-top: -15px;
}

.listing-header {
  margin: 30px 0 0 10px;

  p {
    color: #000;
    /* text-align: center; */
    font-family: "Source Sans Pro";
    font-size: 28px;
    font-style: normal;
    font-weight: 600;
    line-height: 16px; /* 57.143% */
    letter-spacing: 0.5px;
  }
}

.gallry-2 .halfWidth-img .row .col-6 {
  padding-right: 0 !important;
  padding-left: 0 !important;
  float: none !important;
}

@media (max-width: 767px) {
    /** Mobile View*/
    .padding0 {
      padding: 0 !important;
    }
    .corusel-description {
        margin-top: 10px !important;
    }
    .corusel-description span {
        width: 85% !important;
        font-size: 14px;
    }

    .corusel-btn {
        padding: 8px;

        span {
            font-size: 14px;
            padding: 8px 25px;
        }
    }

    .img-description {
        width: 95%;
        margin-left: 0;      
        p {
            color: #000;
            font-family: "Source Sans Pro";
            font-size: 12px;
            font-style: normal;
            font-weight: 400;
            line-height: 16px !important;
            letter-spacing: 0.5px;
        }
    }

    .img-col-5 {
      margin-top: 0;
      height: 100px;
    }

    .img-description-5 {
      margin-top: 50px !important;
      span {
        color: #000;
        display: flex;
        text-align: center;
        align-items: center;
        font-family: "Source Sans Pro";
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 15px; /* 125% */
        letter-spacing: 0.5px;
        padding: 0 0 !important;
      }
    }
    .product-name { 
      color: #060606;
      font-family: "Source Sans Pro";
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
      line-height: 15.665px;
      letter-spacing: 0.49px;
      text-overflow: ellipsis;
    }
    .product-categories {
      font-size: 10px;
      margin-top: -10px;
    }
    .listing-header {
      margin: 10px;

      p {
        color: #000;
      text-align: center;
      font-family: "Source Sans Pro";
      font-size: 18px;
      font-style: normal;
      font-weight: 600;
      line-height: 16px; /* 88.889% */
      letter-spacing: 0.5px;
      text-transform: uppercase;
      }
    }
    .second-gal-hw-img {
      max-height: 248px;
    }
}
</style>



// WEBPACK FOOTER //
// Nomad.vue?1e0c3b1d